/**@jsx jsx */
import { jsx, Flex } from 'theme-ui'
import { Link } from 'gatsby'
import { ReactNode, Fragment } from "react"


type DisclaimerProps = {
  disclaimers?: ReactNode
}
const defaultDisclaimers = [
  {
    item: (
      <Fragment>
        <p>Subject to state regulations, eligibility, credit check, underwriting and approval.
        Rates, terms and conditions apply. Lending decisions and funding times subject to system limitations.
        Some applications may require additional verification, which can delay the lending decision.</p>
      </Fragment>
    )
  },
  {
    item: (
      <Fragment>
        <p><strong>NOTICE:</strong>  The Federal Equal Credit Opportunity Act prohibits creditors from discriminating against credit applicants on the basis
         of race, color, religion, national origin, sex, marital status, age (provided the applicant has the capacity to enter into a binding contract);
         because all or part of the applicant's income derives from any public assistance program; or because the applicant has in good faith exercised any right under the
         Consumer Credit Protection Act. The Federal agency that administers compliance with this law concerning this creditor is the Consumer Financial Protection Bureau, 1700 G Street NW, Washington DC 20006 and the Federal Trade Commission,
         Equal Credit Opportunity, Washington DC 20580.</p>
      </Fragment>
    )
  },
  {
    item: (
      <Fragment>
        <p><strong>Alabama:</strong> Minimum age to apply is 19.</p>
      </Fragment>
    )
  },
  {
    item: (
      <Fragment>
        <p><strong>Texas:</strong> Avío Credit operates as a Registered Credit Access Business (CAB).
        The actual lender is an unaffiliated third party.</p>
      </Fragment>
    )
  },
  {
    item: (
      <Fragment>
        <p><strong>Tennessee:</strong>The State of Tennessee requires a minimum principal reduction.
        In order to comply with the minimum state-required principal reduction,
        Avío Credit requires that minimum payments include a principal reduction of 2.5% or $12.50 for Customers who get paid bi-weekly/twice a month, or
        5% or $25.00 for Customers who get paid monthly, which is greater.</p>
      </Fragment>
    )
  },
]
export const MasterDisclaimer = ({ disclaimers }: DisclaimerProps) => (
    <Fragment>
      <Flex sx={{
        px: 0,
        maxWidth: '1140px',
        mx: 'auto',
        my: '40px',
        flexDirection: 'column',
        rowGap: '20px',
        p: {
          color: 'secondary',
          variant: 'text.bodySansSerif',
          fontSize: '14px',
          lineHeight: '20px',
        }
      }}>
        {defaultDisclaimers.map((content, i) => (
          <div key={i}>
            {content.item}
          </div>
        ))}
      </Flex>
    </Fragment>
  )

  export default MasterDisclaimer